import {ChangeDetectionStrategy, Component} from '@angular/core';
import {RealtimeUsersComponent} from "../../components/realtime-users/realtime-users.component";

@Component({
  selector: 'app-realtime-users',
  templateUrl: './realtime-users.component.html',
  styleUrls: ['./realtime-users.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RealtimeUsersComponent21 extends RealtimeUsersComponent {

  public trackCursor = false;

  hasUsers(){
    return Object.keys(this.usersList).length > 0;
  }

  public getUserAvatar(item){
    return item.avatar !== null ? ("url(" + item.avatar + ")") : "none"
  }

  getUserColor(item){
    return item.color;
  }

  getUserCursorVisibility(){
    return this.trackCursor;
  }

  toggleCursor(){
    this.trackCursor = !this.trackCursor;
    this.editorsProvider.setUserCursorVisibility(this.trackCursor);
    this.cd.detectChanges();
  }
}
